export * from './feld-option-entfernt.interface';
